export default __webpack_public_path__ + "static/media/DIPLOME.4f3e63d1.JPG";